import * as React from "react";
const SvgFiRrTrophyStar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-trophy-star_svg__a)">
      <path
        fill="#062147"
        d="M15.091 15.997C21.662 15.964 24 12.484 24 9.5a3.504 3.504 0 0 0-2.764-3.419c.136-.387.254-.742.334-1.011a3.89 3.89 0 0 0-.627-3.459A3.98 3.98 0 0 0 17.729 0H6.271a3.98 3.98 0 0 0-3.215 1.612A3.89 3.89 0 0 0 2.43 5.07c.08.269.197.624.334 1.011A3.504 3.504 0 0 0 0 9.5c0 2.984 2.339 6.464 8.909 6.497.056.302.091.61.091.923V20c0 1.826-1.536 1.992-2 2H6a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2h-.992c-.472-.008-2.008-.174-2.008-2v-3.08c0-.313.035-.621.091-.923M20.5 8c.827 0 1.5.673 1.5 1.5 0 2.034-1.609 4.197-6.036 4.47.221-.299.474-.576.762-.821 1.739-1.478 2.933-3.453 3.727-5.159.017 0 .03.01.047.01M2 9.5C2 8.673 2.673 8 3.5 8c.017 0 .031-.009.047-.01.794 1.706 1.987 3.68 3.727 5.159q.431.37.762.821C3.609 13.697 2 11.534 2 9.5M10.513 22c.295-.541.487-1.194.487-2v-3.08a6.93 6.93 0 0 0-2.431-5.294C6.8 10.122 5.222 7.459 4.348 4.504a1.9 1.9 0 0 1 .311-1.694c.384-.515.972-.81 1.612-.81h11.457c.64 0 1.228.295 1.612.809a1.91 1.91 0 0 1 .311 1.694c-.875 2.957-2.453 5.619-4.221 7.123a6.93 6.93 0 0 0-2.431 5.294V20c0 .806.191 1.459.487 2zM9.791 9.763a.715.715 0 0 1-.27-.822l.519-1.606-1.366-1a.734.734 0 0 1 .433-1.326h1.681l.511-1.593a.738.738 0 0 1 1.4 0l.51 1.593h1.681a.734.734 0 0 1 .433 1.327l-1.366 1 .519 1.606a.736.736 0 0 1-1.134.818l-1.343-.988-1.344.987a.73.73 0 0 1-.864.004"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-trophy-star_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTrophyStar;
